import * as React from 'react';

import classnames from 'classnames';

import {CalendarXIcon} from 'shells/icon/svg/calendar-x-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {CalendarListItem} from 'shells/scheduler/multiple-conflict-calendars/calendar-list-item';

import type {GetCalendars_calendars as ConflictCalendar} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {PopoverSectionHeader} from './popover-section-header';

import styles from './calendar-status.module.css';

type Props = {
    conflictCalendars: ConflictCalendar[];
};

export function ConflictCalendarsInfo(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <PopoverSectionHeader
                text='Additional calendars'
                ctaText='Go to calendar settings'
                onClick={() => {
                    appHistory.push('/my-account/calendar');
                }}
            />
            <div className='border br-3 pad-8 flex flex-dir-col gap-8'>
                {props.conflictCalendars.map((conflictCalendar) => (
                    <CalendarListItem
                        key={conflictCalendar.id}
                        externalService={
                            conflictCalendar.serviceType === 'OFFICE365' ? 'OFFICE365' : 'GOOGLE'
                        }
                        name={conflictCalendar.name}
                        syncErrors={conflictCalendar.syncErrors}
                        size='small'
                    />
                ))}
            </div>
            <div className={classnames('pad-16', styles.description)}>
                <StackLegacy spacing={12} alignCenter={true} isHorizontal={true}>
                    <CalendarXIcon size={16} alignCenter={true} />
                    We also check here for conflicts when displaying available time slots for your
                    invitees to book.
                </StackLegacy>
            </div>
        </StackLegacy>
    );
}
